import FeedStatusUpdateMapper from './feed-status-update-mapper';

const FeedStatusUpdateModel = {
    mapper: FeedStatusUpdateMapper,

    feedType: {
        fieldName: 'f',
        type: String,
    },

    status: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },
};

export default FeedStatusUpdateModel;
